module.exports = __webpack_public_path__ + "img/zone150300.04f10adf.png";